import { FC, MutableRefObject } from 'react'
import { getStyledNavActions, getStyledTopNavbar, getStyledTopNavItems } from '../../styled-components/NavBar.styled'
import { Logo } from '../icons/Logo.component'
import { MoreIcon } from '../icons/MoreIcon.component'
import { SearchIcon } from '../icons/SearchIcon.component'
import { refTypes } from './NavBar.component'

export interface TopNavBarProps {
    refList: refTypes,
    action: (itemRef: MutableRefObject<any>) => void
}

// #242424

export const TopNavBar: FC<TopNavBarProps> = ({refList, action}) => {
    const StyledTopNavbar = getStyledTopNavbar()
    const StyledNavItemsWrapper = getStyledTopNavItems()
    const StyledNavActions = getStyledNavActions()

    const moveContent = (refItem: MutableRefObject<any>) => {
        action(refItem)
    }

    return (
        <StyledTopNavbar>
            <div>
                <Logo color='#244D4D' />
            </div>
            <div>
                <StyledNavItemsWrapper>
                    <div onClick={() => {moveContent(refList.home)}}>Home</div>
                    <div onClick={() => {moveContent(refList.about)}}>About</div>
                    <div onClick={() => {moveContent(refList.feature)}}>Products</div>
                    <div onClick={() => {moveContent(refList.contact)}}>Contact</div>
                </StyledNavItemsWrapper>
            </div>
            <div>
                <StyledNavActions>
                    <SearchIcon color='#242424' />
                    <MoreIcon color='#242424'/>
                </StyledNavActions>
            </div>
        </StyledTopNavbar>
    )
}